<template>
<div class="tabs-page">
  <header class="tabs-page-header">
    <div class="static-container">
      <h1 class="tabs-page-heading">
        {{ title }}
      </h1>
      <nav class="tabs-page-header-menu">
        <ul>
          <li v-for="tab in tabs">
            <a href="javascript:;" :class="{ 'active': tab.active }" @click="activateTab(tab)">
              {{ tab.label }}
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </header>
  <section class="tabs-page-section">
    <div class="static-container">
      <div class="page-tab-item">
        <component v-bind:is="activeTabComponent"></component>
      </div>
    </div>
  </section>
</div>
</template>

<script>
export default {
  props: ['title', 'tabs'],

  created() {
    this.activeTabComponent = this.tabs[Object.keys(this.tabs)[0]].component
  },

  methods: {
    activateTab(tab) {
      this.tabs.forEach(t => t.active = false)
      tab.active = true

      this.activeTabComponent = tab.component
    },
  },

  data() {
    return {
      activeTabComponent: '',
    }
  }
}
</script>

<style lang="less">
.tabs-page {
  .tabs-page-header {
    @apply bg-primary-lightest px-4;

    .tabs-page-heading {
      @apply py-10 text-3xl font-bold;
    }

    .tabs-page-header-menu {
      ul {
        li {
          @apply inline-block;

          a {
            @apply border-transparent border-solid border-b-2 text-grey-darker pb-2 mr-4 inline-block;

            transition: border-color 0.1s ease-in,
            color 0.1s ease-in;

            &:hover, &.active {
              @apply text-black border-primary;
            }
          }

          &:last-child {
            a {
              @apply mr-0;
            }
          }
        }
      }
    }
  }

  .tabs-page-section {
    @apply w-full bg-white p-4;
  }
}

@screen sm {
  .tabs-page {
    .tabs-page-header {
      .tabs-page-heading {
        @apply text-6xl;
      }
    }
  }
}

@screen lg {
  .tabs-page {
    .tabs-page-header {
      //@apply px-0;
    }

    .tabs-page-section {
      //@apply px-0;
    }
  }
}
</style>
